module.exports = __webpack_public_path__ + "img/marcus-hero-alt.b1e4b461.png";